import React, { useState } from 'react';
import UsersSubscriptionPlansAdminList from './components/UsersSubscriptonPlansAdminList';
import UsersSubscriptionPlansAdminAddPurchasePlanPage from './components/UsersSubscriptonPlansAdminAddSubscriptionPlanPage';
import { Box, Tabs, Tab } from '@mui/material';



const UsersSubscriptionPlansAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="AdSpaces admin tabs">
        <Tab label="List user's Purchase Plans" />
        <Tab label="Insert User's Purchase Plan" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <UsersSubscriptionPlansAdminList />}
        {tab === 1 && <UsersSubscriptionPlansAdminAddPurchasePlanPage />}
      </Box>
    </Box>
  );
};

export default UsersSubscriptionPlansAdminPage;